import React, { useState } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import Logo from 'components/Logo';
import UserMenu from './components/UserMenu';
import LoginForm from './components/LoginForm';
import GlobalSearch from './components/GlobalSearch';
import SideMenu from './components/SideMenu';
import MainNavigation from './components/MainNavigation';
import MenuToggle from './components/MenuToggle';
import UxHelpers from 'helpers/ux-helpers.js';
import { User } from 'redux/actions/user';
import headerBackground from 'assets/images/header_back.jpg';
import './styles.css';

const logoStyles = {
  width: '100%',
};

const Header = props => {
  const { firmName, user, onFormSubmit, updateUserOption, options } = props;
  const { isLoggedIn, authError, counters } = user;
  const [toggled, setState] = useState(false);
  const [showMobileNav, toggleMobileNav] = useState(false);

  const toggleHandler = () => {
    setState(!toggled);
  };

  const toggleMobileMenuHandler = toggled => {
    if (!!toggled) {
      toggleMobileNav(true);
      UxHelpers.overlay('show');
    } else {
      UxHelpers.overlay('hide');
      toggleMobileNav(false);
    }
  };

  const headerActions = {
    toggleMobileMenuHandler,
    updateUserOption,
  };

  return (
    <header
      className={
        isLoggedIn ? 'header app__header header--logged-in' : 'header app__header header--guest'
      }
    >
      <div
        aria-hidden={true}
         style={{
           backgroundImage: `url(${headerBackground})`,
         }}
         className="header__background"
      />
      <div className="header__top">
        <div
          className={
            toggled
              ? 'header__pusher header__pusher--toggled-sidenav'
              : 'header__pusher'
          }
        >
          <div className="header__logo">
            <Logo btnStyles={logoStyles} />
          </div>

          {isLoggedIn && (
            <MediaQuery query="(min-width: 1100px)">
              <div className="header__global-search">
                <GlobalSearch user={user} />
              </div>
            </MediaQuery>
          )}

          <div className="header__user-menu">
            {isLoggedIn ? (
              <UserMenu
                user={user}
                counters={{ inbox: counters.inbox }}
                actions={headerActions}
              />
            ) : (
              <MediaQuery query="(min-width: 1200px)">
                <div className="header__login-form">
                  <LoginForm
                    onFormSubmit={onFormSubmit}
                    authError={authError}
                  />
                </div>
              </MediaQuery>
            )}
          </div>

          {!isLoggedIn && (
            <div className="header__menu-toggle">
              <MenuToggle toggled={toggled} toggleFunc={toggleHandler} />
            </div>
          )}
        </div>

        <div className="header__side-nav">
          <SideMenu
            toggled={toggled}
            toggleFunc={toggleHandler}
            onFormSubmit={onFormSubmit}
            authError={authError}
          />
        </div>
      </div>

      {!isLoggedIn
        ? firmName && <h1 className="header__title">{firmName}</h1>
        : null}

      {options && !!options.title && (
        <h1 className={'header__title'}>{options.title}</h1>
      )}

      {isLoggedIn && (
        <MediaQuery query="(max-width: 1099px)">
          <div className="header__middle">
            <div className="container">
                <div className="header__global-search">
                  <GlobalSearch user={user} />
                </div>
            </div>
          </div>
        </MediaQuery>
      )}

      {isLoggedIn && (
        <div className="header__bottom">
          <div className="container">
              <MainNavigation
                user={user}
                counters={counters}
                showMobileNav={showMobileNav}
                actions={headerActions}
              />
          </div>
        </div>
      )}
    </header>
  );
};

const mapDispatchToProps = dispatch => ({
  onFormSubmit: (login, password) => dispatch(User.signIn({ login, password })),
  updateUserOption: option => dispatch(User.updateUserOption(option)),
});

export default connect(
  null,
  mapDispatchToProps
)(Header);
